import React, {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';
import styles from "./Footer.module.scss";

import classNames from "classnames";

import JSONContent from "./content";

const Footer = ({
                      id = '',  isMobile = false
                }) => {
    const [loaded, setLoaded] = useState(false);

    const isA = true;

    const curYear = new Date();
    useEffect(() => {
        if (!loaded) {
            setLoaded(true);
        }
    }, [loaded]);


    let language = process.env.REACT_APP_LANG === 'spanish' ? 'spanish' : 'english';
    const content: any = JSONContent[language as keyof object];
    const {ref} = useInView({
        threshold: .5,
        triggerOnce: true
    });

    const linkAltText = (language === 'spanish') ? "abre en una nueva ventana del navegador" : "opens in a new browser window.";

    return (
        <>
                <footer id={id}
                    ref={ref} data-tracking='section-footer'
                    className={classNames([`${!isMobile && window.innerWidth < 1000 ? styles.zoomedIn : '' }`, 'no-parallax'])}
                >
                    <div className={styles.container}>
                        <div id="externalLinks" className={classNames({[styles.externalLinks]: true,})}>
                            <ul>
                                <li><a target="_blank" href={content.links.privacy.url} aria-label={content.links.privacy.label + ' - ' + linkAltText}>{content.links.privacy.label}</a></li>
                                <li><a id="ot-sdk-link" className="ot-sdk-show-settings" href={content.links.oneTrust.url} aria-label={content.links.oneTrust.label + ' - ' + linkAltText}>{content.links.oneTrust.label}</a></li>
                                <li><a target="_blank" href={content.links.data.url} aria-label={content.links.data.label + ' - ' + linkAltText}>{content.links.data.label}</a></li>
                                <li><a target="_blank" href={content.links.terms.url} aria-label={content.links.terms.label + ' - ' + linkAltText}>{content.links.terms.label}</a></li>
                                <li><a target="_blank" href={content.links.access.url} aria-label={content.links.access.label + ' - ' + linkAltText}>{content.links.access.label}</a></li>
                                <li><a target="_blank" href={content.links.fraud.url} aria-label={content.links.fraud.label + ' - ' + linkAltText}>{content.links.fraud.label}</a></li>
                                <li><a target="_blank" href={content.links.sitemap.url} aria-label={content.links.sitemap.label + ' - ' + linkAltText}>{content.links.sitemap.label}</a></li>
                                <li><a target="_blank" href={content.links.home.url} aria-label={content.links.home.label + ' - ' + linkAltText}>{content.links.home.label}</a></li>
                                <li><a target="_blank" href={content.links.about.url} aria-label={content.links.about.alt + ' - ' + linkAltText}>{content.links.about.label}</a></li>
                                <li><a target="_blank" href={content.links.careers.url} aria-label={content.links.careers.label + ' - ' + linkAltText}>{content.links.careers.label}</a></li>
                                <li><a
                                    onKeyDown={(e) => {
                                        // e.preventDefault();
                                        if (e.key === "Tab") {
                                            const externalLinks = document.querySelectorAll('#externalLinks a');
                                            const secondToLast = document.querySelectorAll('#externalLinks a')[externalLinks.length - 2] as HTMLElement;
                                            if (e.shiftKey) {
                                                secondToLast!.focus();
                                            }
                                        }
                                    }}
                                    onKeyUp={(e)=>{e.preventDefault()}}
                                    target="_blank" href={content.links.diversity.url} aria-label={content.links.diversity.label + ' - ' + linkAltText}>{content.links.diversity.label}</a></li>
                            </ul>
                        </div>
                        <p id="lastElement">&copy; 1999 - {curYear.getFullYear()} {content.fdic}</p>
                    </div>
                </footer>
        </>
    );
};

export default Footer;
